import * as R from "ramda";
import { validateObject, validateField } from "util/validation";
import { curry } from "ramda";
import { notBlank } from "../util/ext";

const programConstraints = {
  programName: {
    presence: {
      allowEmpty: false,
      message: "^Name must not be blank",
    },
  },
  // programKey: {
  //   presence: {
  //     allowEmpty: false,
  //     message: "^Key must not be blank",
  //   },
  // },
};

export const validateProgramField = (field, value, errors = {}) =>
  validateField(programConstraints, field, value, errors);

export const validateProgram = R.partial(validateObject, [programConstraints]);

export const hasError = curry((errors, field) => notBlank(errors[field]));

export const firstError = curry((errors, field) =>
  errors[field] ? errors[field][0] : "",
);
